/*
DO NOT MANUALLY TRANSLATE!
Follow the instructions in the README.md to conveniently update translations.
*/

export default {
  "CookieMessage.old.link": "Mais informações",
  "CookieMessage.old.text":
    "Utilizamos cookies para permitir o bom funcionamento da nossa loja online. Veja a nossa política de cookies.",
  "CookieMessage.link": "Aceitação dos cookies",
  "CookieMessage.more_information": "Leia mais sobre os Cookies da Kramp",
  "CookieMessage.return": "Voltar atrás",
  "CookieMessage.intro.body":
    'Estes cookies foram instalados pela Kramp, bem como por terceiros. Salvaguardamos a sua privacidade. Ao clicar na opção "Aceitar cookies" abaixo, está a concordar com a utilização destes cookies. Ao aceitar estes cookies, está a garantir o funcionamento correto do nosso website. Exemplos da utilização destes cookies',
  "CookieMessage.intro.list.1": "Início de sessão automático em A Minha Conta",
  "CookieMessage.intro.list.2":
    "Análise do comportamento do visitante, de forma a melhorar o website",
  "CookieMessage.intro.list.3":
    "Criação de perfis de clientes para nos permitir fornecer informações e anúncios personalizados",
  "CookieMessage.intro.extra":
    'Se não desejar aceitar todos os cookies, pode fazê-lo nas suas <a>definições</a>. Para mais informações, leia a nossa <a href="{legalLink}">política de privacidade e de cookies</a>',
  "CookieMessage.intro.title": "A Kramp utiliza cookies",
  "CookieMessage.settings.body":
    "Pode escolher entre três definições de cookies. Ao escolher as definições padrão, irá permitir-nos fornecer a melhor experiência online.",
  "CookieMessage.settings.standard.title": "Padrão (mais popular)",
  "CookieMessage.settings.standard.body":
    "Os cookies são utilizados para iniciar sessão, análise de encomendas, informações personalizadas, redes sociais e cookies de terceiros.",
  "CookieMessage.settings.restricted.title": "Limitado",
  "CookieMessage.settings.restricted.body":
    "Os cookies utilizados para iniciar sessão, análise de encomendas e informações pessoais.",
  "CookieMessage.settings.highly_restricted.title": "Extremamente limitado",
  "CookieMessage.settings.highly_restricted.body":
    "Permite apenas o número mínimo de cookies. Utilizado apenas para iniciar sessão, efetuar encomendas e permitir que o website funcione de forma razoável.",
  "CookieMessage.settings.options.title": "O que fazemos:",
  "CookieMessage.settings.option.1":
    "Utilizamos cookies para garantir que este website funciona corretamente",
  "CookieMessage.settings.option.2":
    "Investigamos o comportamento do utilizador",
  "CookieMessage.settings.option.3": "Monitorizamos as estatísticas pessoais",
  "CookieMessage.settings.option.4":
    "Apresentamos informações que podem ser do seu interesse",
  "CookieMessage.settings.option.5":
    "Utilizamos informações para os nossos anúncios",
  "CookieMessage.settings.option.6": "Monitorizamos estatísticas anónimas",
  "CookieMessage.settings.option.7": "Partilhamos os seus dados pessoais",
  "CookieMessage.settings.title": "Definições de cookies",
  "CookiePage.url": "politica-de-privacidad-cookies",
};
